import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { JackpotDetailPage } from './jackpot-detail';
import { BaselineSharedModule } from 'baseline-lib';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [
    JackpotDetailPage,
  ],
  imports: [
    SharedModule,
    IonicPageModule.forChild(JackpotDetailPage),
  ],
})
export class JackpotDetailPageModule {}



// WEBPACK FOOTER //
// ./src/app/sports/jackpot-detail/jackpot-detail.module.ts